<template>
  <v-container
    class="mt-3"
  >
    <v-row>
      <!-- No trigger display START -->
      <template v-if="!hmdFunction.triggers.length > 0">
        <new-jumbotron
          :my-jumbotron="noTriggerFoundJumbotron"
          :fn="hmdFunction"
        />
      </template>
      <!-- No trigger display END -->

      <!-- Trigger display START -->
      <template v-else>
        <!-- Search bar START -->
        <!-- <v-toolbar class="sub-menu-filter mt-2" height='20px' flat color="grey lighten-5" >
          <v-flex xs2 class="hidden-sm-and-down top-menu">
            <v-text-field
                append-icon="search"
                label="Search"
                single-line
                hide-details
                @input="searchHandler"
                :value="mySearch"
              ></v-text-field>
          </v-flex>
          <v-spacer></v-spacer>
          <v-toolbar-items class="hidden-sm-and-down" dark>
            <v-btn flat :color="mySelectedItems === 'All' ? 'primary' : 'grey lighten-1'" class="caption" @click.native="selectedItemsHandler('All')">All</v-btn>
            <v-btn flat :color="mySelectedItems === 'Active' ? 'primary' : 'grey lighten-1'" class="caption" @click.native="selectedItemsHandler('Active')">Active</v-btn>
            <v-btn flat :color="mySelectedItems === 'Inactive' ? 'primary' : 'grey lighten-1'" class="caption" @click.native="selectedItemsHandler('Inactive')">Inactive</v-btn>
          </v-toolbar-items>
        </v-toolbar> -->
        <!-- Search bar END -->
        <v-row>
          <!-- add trigger card START -->
          <v-col
            class="x12"
            sm="6"
            md="4"
            lg="4"
          >
            <v-card
              height="100%"
              color="grey lighten-4"
              hover
              :to="{path : '/projects/'+$route.params.project+'/create/trigger',query : {function:hmdFunction.name}}"
            >
              <v-container
                class="fill-height"
                fluid
              >
                <v-row
                  align="center"
                  justify="center"
                >
                  <v-col class="text-center">
                    <v-card-text class="title font-weight-thin">
                      <v-icon left>
                        mdi-plus
                      </v-icon>
                      <span>New</span>
                      </v-iconleft>
                    </v-card-text>
                  </v-col>
                </v-row>
              </v-container>
            </v-card>
          </v-col>
          <!-- add trigger card END -->

          <!-- trigger cards START -->
          <template
            v-for="(trigger , key) in hmdFunction.triggers"
          >
            <v-col
              v-if="isShown(trigger)"
              :key="key"
              cols="12"
              sm="6"
              md="4"
              lg="4"
            >
              <trigger-card
                :trigger="trigger"
                :is-new="false"
                @deleteTrigger="deleteTrigger"
              />
            </v-col>
          </template>
          <!-- trigger cards END -->
        </v-row>
      </template>
      <!-- Trigger display END -->
    </v-row>
  </v-container>
</template>

<script>
  import TriggerCard from '../../../UIComponents/Cards/TriggerCard.vue'
  import NewJumbotron from '../../../UIComponents/Jumbotron.vue'

  export default {
    components: {
      TriggerCard,
      NewJumbotron,
    },
    props: {
      hmdFunction: {
        type: Object,
        default: function () {
          return {}
        },
      },
      search: {
        type: String,
        default: function () {
          return ''
        },
      },
      selectedItems: {
        type: String,
        default: function () {
          return 'All'
        },
      },
    },
    data: function () {
      return {
        noTriggerFoundJumbotron: {
          type: 'noTriggerFunction',
          heading: "You don't have any trigger",
          subHeading: 'Make this function execute whenever you want based on time elements, dataset manipulation or api call',
          elementList: [
            { text: 'every hour, day, month and/or year,' },
            { text: 'before or after an update, an insert or a read on a dataset,' },
            { text: 'before or after a call on an API' },
          ],
          dividerHeading: 'Create your first trigger now!',
        },
      }
    },
    computed: {
      mySearch: function () {
        return this.search
      },
      mySelectedItems: function () {
        return this.selectedItems
      },
    },
    methods: {
      deleteTrigger (obj) {
        this.$emit('deleteTrigger', { 'id': obj.id, 'type': obj.type })
      },
      isShown (item) {
        var label
        var isLabelContained = false
        for (label in item.function.labels) {
          if (item.function.labels[label].name.includes(this.mySearch)) {
            isLabelContained = true
          }
        }
        if (this.mySelectedItems === 'All' ||
          (this.mySelectedItems === 'Active' && item.enabled === true) ||
          (this.mySelectedItems === 'Inactive' && item.enabled === false)) {
          if (this.mySearch === '' || item.function.name.includes(this.mySearch) || item.type.includes(this.mySearch) || isLabelContained === true) {
            return true
          } else {
            return false
          }
        } else {
          return false
        }
      },
      searchHandler: function (search) {
        this.$emit('searchHandler', search)
      },
      selectedItemsHandler: function (selectedItems) {
        this.$emit('selectedItemsHandler', selectedItems)
      },
    },
  }

</script>
